import { allSessions } from './db';

function dayKey(d: Date): string {
  return d.toISOString().slice(0, 10);
}

export async function computeStreak(): Promise<number> {
  const sessions = await allSessions();
  if (sessions.length === 0) return 0;
  const active = new Set(sessions.filter((s) => s.problems > 0).map((s) => s.date));
  let streak = 0;
  const cursor = new Date();
  // If today not active, streak can still start from yesterday.
  if (!active.has(dayKey(cursor))) {
    cursor.setDate(cursor.getDate() - 1);
  }
  while (active.has(dayKey(cursor))) {
    streak += 1;
    cursor.setDate(cursor.getDate() - 1);
  }
  return streak;
}
